var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.paneInfo.loading)?_c('div',[_vm._v("Loading...")]):_c('div',[_c('sales-table',{attrs:{"manager":_vm.manager}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }